import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "product-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "product-detail-container"
}
const _hoisted_3 = { class: "product-details-section" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = {
  key: 1,
  class: "error-container"
}
const _hoisted_6 = {
  key: 2,
  class: "detail-images-grid"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "product-info-section" }
const _hoisted_9 = { class: "product-title" }
const _hoisted_10 = { class: "product-price" }
const _hoisted_11 = { class: "product-description" }
const _hoisted_12 = { class: "product-details-section" }
const _hoisted_13 = {
  key: 0,
  class: "detail-images-grid"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "empty-container"
}
const _hoisted_16 = {
  key: 1,
  class: "loading-container"
}

import { ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { watch } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'MollyProductDetail',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { t, locale } = useI18n();

// 产品数据
const product = ref<any>(null);
const category = ref<string>('');

// 产品详情图片数据
const detailImages = ref<any[]>([]);
const loadingImages = ref<boolean>(false);
const errorImages = ref<string>('');

// 返回上一页
const goBack = () => {
  router.back();
};

// 获取当前语言
const currentLanguage = computed(() => locale.value);

// 从URL参数中获取产品数据
onMounted(() => {
  try {
    const productStr = route.query.product as string;
    const categoryStr = route.query.category as string;
    if (productStr) {
      product.value = JSON.parse(productStr);
      category.value = categoryStr || '';
      // 获取产品详情图片
      if (product.value.id) {
        fetchProductDetailImages(product.value.id);
      }
    }
  } catch (error) {
    console.error('解析产品数据失败:', error);
  }
});

// 监听语言变化，更新产品详情图片
watch(
  () => locale.value,
  (newLocale) => {
    // 语言变化时，不需要重新获取数据，直接切换显示的图片字段
    console.log('Language changed to:', newLocale);
  }
);

// 获取产品详情图片数据
const fetchProductDetailImages = async (productId: number) => {
  if (!productId) return;
  
  loadingImages.value = true;
  errorImages.value = '';
  
  try {
    const response = await fetch(`/jeecg-boot/energycube/topicImg/queryDetail?id=${productId}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // 检查响应代码
    if (data.code === 200) {
      // 按sort字段排序图片
      detailImages.value = data.result.sort((a: any, b: any) => a.sort - b.sort);
    } else {
      throw new Error(data.message || '获取产品详情图片失败');
    }
  } catch (err) {
    errorImages.value = err instanceof Error ? err.message : '未知错误';
    console.error('获取产品详情图片失败:', err);
  } finally {
    loadingImages.value = false;
  }
};

// 根据当前语言获取图片URL
const getImageUrl = (image: any) => {
  if (!image) return '';
  // 根据当前语言选择不同的图片字段
  return currentLanguage.value === 'zh-Hant' ? image.imgUrl : image.imgUrlen;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "back-button",
      onClick: goBack
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, [
        _createElementVNode("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" })
      ], -1),
      _createElementVNode("span", null, "返回", -1)
    ]))]),
    (product.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "section-subtitle" }, "产品详情", -1)),
            (loadingImages.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "loading-spinner" }, null, -1),
                  _createElementVNode("p", null, "加载详情图片中...", -1)
                ]))]))
              : (errorImages.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", null, "加载详情图片失败: " + _toDisplayString(errorImages.value), 1)
                  ]))
                : (detailImages.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailImages.value.slice(0, Math.ceil(detailImages.value.length / 2)), (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: image.id || index,
                          class: "detail-image-item"
                        }, [
                          _createElementVNode("img", {
                            src: getImageUrl(image),
                            alt: product.value.name + ' 详情图' + (index + 1)
                          }, null, 8, _hoisted_7)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h1", _hoisted_9, _toDisplayString(product.value.name), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(product.value.price), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(product.value.description), 1),
            _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"product-features\" data-v-dd835814><div class=\"feature-item\" data-v-dd835814><span class=\"feature-icon\" data-v-dd835814>⚡</span><span class=\"feature-text\" data-v-dd835814>快速充电</span></div><div class=\"feature-item\" data-v-dd835814><span class=\"feature-icon\" data-v-dd835814>🔌</span><span class=\"feature-text\" data-v-dd835814>多重保护</span></div><div class=\"feature-item\" data-v-dd835814><span class=\"feature-icon\" data-v-dd835814>🌍</span><span class=\"feature-text\" data-v-dd835814>全球通用</span></div><div class=\"feature-item\" data-v-dd835814><span class=\"feature-icon\" data-v-dd835814>🔧</span><span class=\"feature-text\" data-v-dd835814>易于安装</span></div></div><div class=\"action-buttons\" data-v-dd835814><button class=\"contact-button\" data-v-dd835814>联系我们</button><button class=\"inquiry-button\" data-v-dd835814>咨询详情</button></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_12, [
            (detailImages.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailImages.value.slice(Math.ceil(detailImages.value.length / 2)), (image, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: image.id || index,
                      class: "detail-image-item"
                    }, [
                      _createElementVNode("img", {
                        src: getImageUrl(image),
                        alt: product.value.name + ' 详情图' + (index + Math.ceil(detailImages.value.length / 2) + 1)
                      }, null, 8, _hoisted_14)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!loadingImages.value && !errorImages.value && detailImages.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("p", null, "暂无产品详情图片", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "loading-spinner" }, null, -1),
          _createElementVNode("p", null, "加载中...", -1)
        ]))]))
  ]))
}
}

})